import type { CustomTooltipProps } from 'ag-grid-react'

type RowHoverTooltipProps = Pick<CustomTooltipProps<unknown, React.ReactNode>, 'value'>

export function RowHoverTooltip({ value }: RowHoverTooltipProps) {
  return <>{value}</>
}
